import React from "react";
import homeImage from "./Images/card img.webp"; // Use only the desired image
import Vision from "./Vision/Vision";

function HomePage() {
  return (
    <div className="bg-gray-100">
      {/* Hero section */}
      <div className="bg-white text-gray-900 py-10 sm:py-10 md:py-10">
        <div className="container mx-auto px-4 sm:px-6 md:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            {/* Text Section */}
            <div className="flex flex-col z-10">
              <h1 className="text-3xl sm:text-4xl md:text-5xl text-[#e64a32] font-bold mb-4">
                Welcome to the Passion PRUTL Game Zone
              </h1>
              <p className="text-base sm:text-lg md:text-lg mb-8 text-gray-900">
              At PASSION PRUTL, we believe in fostering holistic well-being by creating innovative card games that inspire individuals from all walks of life, including students, freshers, job seekers, homemakers, professionals, and CXOs.
              </p>
              <p className="text-sm sm:text-sm md:text-sm mb-4 text-gray-900">
   Our games are designed to engage players with themes ranging from engineering to STEAM+Humanity, encompassing critical topics such as AI governance, data privacy, information security, and quality assurance.
   <p className="text-gray-900">
              By leveraging the PASSION FRAMEWORK and PRUTL dimensions—Positive Soul, Negative Soul, Positive Materialism, and Negative Materialism—we aim to empower individuals to understand the intricate balance of human emotions and material realities. With the integration of cutting-edge tools like Large Language Models (LLMs), our card games enable an analysis of human decision-making, incorporating human-in-the-loop interactions for scoring mechanisms.</p>
    <p>Founded by Dr. Prakash Sharma, PASSION PRUTL is a "Made in India" initiative dedicated to transforming card games into a platform for creating micro-entrepreneurs and nurturing communities for collective well-being.</p>
              </p>
              <p className="text-base sm:text-base md:text-sm mb-4 text-gray-900">
              <p>We stand apart by addressing societal challenges, such as gambling addiction, with a firm commitment to promoting positive life paths through the principles of KARMA. Our games are not just a form of entertainment but a journey of self-discovery, awakening, and transformation.</p>
              </p>
            </div>
            {/* Image Section */}
            <div className="relative w-full h-64 sm:h-72 md:h-[22rem]">
              <img
                src={homeImage}
                alt="Home"
                className="w-full h-full object-cover rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </div>
      {/* Vision section */}
      <Vision />
    </div>
  );
}

export default HomePage;
